var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center position-relative",style:({..._vm.fullPaddingSubject(_vm.section.options.customize.style), ..._vm.opacity, ..._vm.dropShadow, ..._vm.marginV2, ..._vm.transform})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }